import { double } from "vee-validate/dist/rules";

export default class Spike {
    constructor(signal, peaks, left, right) {
        this.signal = signal.map(Number);
        this.peaks = peaks;
        this.left_trough = left;
        this.right_trough = right;
        this.left_spike = this.calculateLeftSpikeHeight(this.peaks, this.left_trough);
        this.right_spike = this.calculateRightSpikeHeight(this.peaks, this.right_trough);
        this.mean_spike = this.calculateMeanSpikeHeight(this.left_spike, this.right_spike);
        this.max_spike = this.calculateMaxSpikeHeight(this.left_spike, this.right_spike);
        this.min_spike = this.calculateMinSpikeHeight(this.left_spike, this.right_spike);
    }

    // method
    calculateLeftSpikeHeight(peaks, left_trough) {
        let left_spike = new Array(peaks.length).fill(0.0);

        for (let i = 0; i < peaks.length; i++) {
            if (left_trough[i] != -1) {
                left_spike[i] = Math.abs(this.signal[peaks[i]] - this.signal[left_trough[i]]);
            }
            else {
                left_spike[i] = double.NaN;
            }
        }

        return left_spike;
    }

    calculateRightSpikeHeight(peaks, right_trough) {
        let right_spike = new Array(peaks.length).fill(0.0);

        for (let i = 0; i < peaks.length; i++) {
            if (right_trough[i] != -1) {
                right_spike[i] = Math.abs(this.signal[peaks[i]] - this.signal[right_trough[i]]);
            }
            else {
                right_spike[i] = double.NaN;
            }
        }

        return right_spike;
    }

    calculateMeanSpikeHeight(left_spike, right_spike) {
        let mean_spike = new Array(left_spike.length).fill(0.0);

        for (let k = 0; k < mean_spike.length; k++) {
            if (left_spike[k] != double.NaN && right_spike[k] != double.NaN) {
                mean_spike[k] = (left_spike[k] + right_spike[k]) / 2;
            }
            else if (left_spike[k] != double.NaN && right_spike[k] == double.NaN) {
                mean_spike[k] = left_spike[k];
            }
            else if (left_spike[k] == double.NaN && right_spike[k] != double.NaN) {
                mean_spike[k] = right_spike[k];
            }
        }

        return mean_spike;
    }

    calculateMaxSpikeHeight(left_spike, right_spike) {
        let max_spike = new Array(left_spike.length).fill(0.0);

        for (let k = 0; k < max_spike.length; k++) {
            if (left_spike[k] == double.NaN) {
                max_spike[k] = right_spike[k];
            }
            else if (right_spike[k] == double.NaN) {
                max_spike[k] = left_spike[k];
            }
            else {
                max_spike[k] = Math.max(left_spike[k], right_spike[k]);
            }
        }

        return max_spike;
    }

    calculateMinSpikeHeight(left_spike, right_spike) {
        let min_spike = new Array(left_spike.length).fill(0.0);

        for (let k = 0; k < min_spike.length; k++) {
            if (left_spike[k] == double.NaN) {
                min_spike[k] = right_spike[k];
            }
            else if (right_spike[k] == double.NaN) {
                min_spike[k] = left_spike[k];
            }
            else {
                min_spike[k] = Math.min(left_spike[k], right_spike[k]);
            }
        }

        return min_spike;
    }

    getMeanSpike() {
        return this.mean_spike;
    }

    getLeftSpike() {
        return this.left_spike;
    }

    getRightSpike() {
        return this.right_spike;
    }

    getMaxSpike() {
        return this.max_spike;
    }

    filterByProperty(lower_threshold, upper_threshold, spikeType) {
        let newPeaks = new Array();
        let spikeList = [];

        if (spikeType == "left") {
            spikeList = this.left_spike;
        }
        else if (spikeType == "right") {
            spikeList = this.right_spike;
        }
        else if (spikeType == "mean") {
            spikeList = this.mean_spike;
        }
        else if (spikeType == "max") {
            spikeList = this.max_spike;
        }
        else if (spikeType == "min") {
            spikeList = this.min_spike;
        }
        else {
            // throw new IllegalArgumentException("spikeType Can only be 'left', 'right', 'mean' and 'max'");
            return null;
        }

        if (lower_threshold == null && upper_threshold == null) {
            // throw new IllegalArgumentException("All thresholds cannot be null");
            return null;
        }
        else if (lower_threshold != null && upper_threshold == null) {
            for (let i = 0; i < spikeList.length; i++) {
                if (spikeList[i] == double.NaN) {
                    continue;
                }
                if (spikeList[i] > lower_threshold) {
                    newPeaks.push(this.peaks[i]);
                }
            }
        }
        else if (lower_threshold == null && upper_threshold != null) {
            for (let i = 0; i < spikeList.length; i++) {
                if (spikeList[i] == double.NaN) {
                    continue;
                }
                if (spikeList[i] < upper_threshold) {
                    newPeaks.push(this.peaks[i]);
                }
            }
        }
        else {
            for (let i = 0; i < spikeList.length; i++) {
                if (spikeList[i] == double.NaN) {
                    continue;
                }
                if (spikeList[i] > lower_threshold && spikeList[i] < upper_threshold) {
                    newPeaks.push(this.peaks[i]);
                }
            }
        }
        return this.convertToPrimitiveInt(newPeaks);
    }

    convertToPrimitiveInt(l) {
        let ret = new Array(l.length).fill(0);

        for (let i = 0; i < ret.length; i++) {
            ret[i] = l[i];
        }

        return ret;
    }
}